import postRequest from '@helpers/api/post';
import putRequest from '@helpers/api/put';

/**
 * @typedef {Object} InviteUser
 * @property {string} id - unique identifier
 * @property {string} firstName - first name
 * @property {string} lastName - last name
 * @property {string} email - email
 * @property {string} password - password
 * @property {string} mobile - mobile
 */

/**
 * @typedef {Object} VerifyCode
 * @property {string} email - email
 * @property {string} otp - otp
 */

/**
 * invite user request
 * @param {InviteUser} payload - payload
 * @returns {Promise<*>}
 */
export const inviteUserRequest = payload => putRequest('auth/acceptUserInvitation/', payload);

/**
 * verify code
 * @param {VerifyCode} payload - payload
 * @returns {Promise<*>}
 */
export const verifyCode = ({ email, otp }) =>
  postRequest('auth/verifyInvitationPhoneNumber/', { email, otp });
